export default __webpack_public_path__ + "static/media/30190_KS2_WX1_ZAM_HW-1_1_S-1_2018b.1ed279d2.gif";